import {
  Component, Input
} from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
@Component({
  selector: 'app-heading-block-one',
  templateUrl: './heading-block-one.component.html',
  styleUrls: ['./heading-block-one.component.scss'],
  standalone:false
})
export class HeadingBlockOneComponent extends CoreClass {
  @Input() heading: string | null = '';
  @Input() class: string | null = '';
  @Input() title: string | null = '';
  @Input() description: string | null = '';
  @Input() style: string | object = '';
  @Input() descriptionstyle: string | object = '';
  @Input() headingStyle: string | null = ''
  @Input() mainheading: string | null = '';
  @Input() mainiheading : string | null = '';
  @Input() sectionheading : string | null ='';
}
